import React, { useEffect, useState } from "react"
import { Container, IconButton, InputAdornment, Menu, TextField } from "@mui/material"
import { useNavigate } from "react-router-dom";
import { StyledTextField, muistyles } from "../../../utils/muistyles";
import { Search, Clear } from "@mui/icons-material";



const Shopbyconditionbutton = ({ conditions }) => {
    const navigate = useNavigate()

    const [displayedconditions, setdisplayedconditions] = useState([]);

    const [hint, sethint] = useState('');

    const [anchorEl, setAnchorEl] = useState('');
    const open = Boolean(anchorEl);

    useEffect(() => {
      setdisplayedconditions(conditions)
    }, [conditions]);



    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    const navigatetoitems = (condition) => {
        handleClose()
        //classifications
        navigate(`/classifications/${condition.categoryName}`, {
            state: {
                classification: condition,
                classifications: conditions
            }
        })
    }

    //search hint
    const onsearch = (text) => {
        sethint(text)
        if (text) {
            const hintLowerCase = text?.toLowerCase().replace(/\s+/g, '');
            setdisplayedconditions(
                conditions.filter((element) => {
                    const elementname = element.categoryName?.toLowerCase().replace(/\s+/g, '');
                    return elementname?.includes(hintLowerCase);
                })
            )
        } else {
            setdisplayedconditions(conditions)
        }
    }

    //on clear search
    const clearsearch = () => {
        sethint('')
        setdisplayedconditions(conditions)
    }


    return (
        <div>
            <div className="link" onMouseEnter={handleClick} onClick={handleClick}>Shop By Classification</div>
            <Menu
                id="basic-menu"
                sx={{ marginTop: 2 }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                    dense: true
                }}
            >
                <div className="wrapconditionsmain" onMouseLeave={handleClose}>
                    <div className="textfieldsearch">
                        <StyledTextField
                            placeholder="Search classification"
                            variant="outlined"
                            value={hint}
                            onChange={(e) => onsearch(e.target.value)}
                            InputProps={{
                                endAdornment: <IconButton onClick={() => clearsearch()}> {hint ? <Clear /> : <Search />} </IconButton>,
                                style: {
                                    borderRadius: "30px",
                                }
                            }}
                        />
                    </div>
                    <div className="wrapconditionslink"  >
                        <div className="wrapconditionslinkdivs">
                            {displayedconditions.slice(0, (displayedconditions.length / 2)).map((val, key) => {
                                return (
                                    <div onClick={() => navigatetoitems(val)} className="conditionlink" key={key}>{_.startCase(val.categoryName)}</div>
                                )
                            })}
                        </div>
                        <div className="wrapconditionslinkdivs">
                            {displayedconditions.slice((displayedconditions.length / 2) + 1, displayedconditions.length).map((val, key) => {
                                return (
                                    <div onClick={() => navigatetoitems(val)} className="conditionlink" key={key}>{_.startCase(val.categoryName)}</div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </Menu>
        </div>
    )
}

export default Shopbyconditionbutton